'use strict';
const normalisedKey = (domEvent) => {
	const legacyMappings = {
			' ': 'SPACE',
			'ArrowUp': 'UP',
			'ArrowDown': 'DOWN',
			'ArrowLeft': 'LEFT',
			'ArrowRight': 'RIGHT',
			'Delete': 'DEL',
			'Escape': 'ESC'
		},
		keyVal = domEvent.key && (legacyMappings[domEvent.key] || domEvent.key.toUpperCase());
	if (domEvent.altKey || keyVal === 'DEAD') {
		const codeVal = domEvent.code;
		if (codeVal) {
			return codeVal.replace(/^(Key|Digit|Numpad)/i, '');
		}
	}
	return keyVal;
};
module.exports = function toHotKeyLabel(domEvent) {
	const modifiers = ['alt', 'shift', 'ctrl', 'meta'].filter(modifier => domEvent[modifier + 'Key']);
	return modifiers.concat(normalisedKey(domEvent)).join('+').toUpperCase();
};
